import { useState, useEffect, useRef } from "react";
import "./courses-details.scss";
import MusicIcon from "../../assets/icons/music.svg";
import nextarrow from "../../assets/icons/nexticon.svg";
import { ApiGet, ApiPost } from "../../Helpers/Api/ApiData";
import { ToastContainer, toast } from "react-toastify";
import { useParams, useHistory } from "react-router-dom";
import Courses from "../courses";
import LinearProgress from "@mui/material/LinearProgress";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import * as userUtil from "../../utils/user.util";
import { StylesProvider } from "@material-ui/core";
import ReactPlayer from "react-player";

export default function CoursesDetails() {
  const { id } = useParams();
  let userInfo = userUtil.getUserInfo();
  const [lessonData, setLessonData] = useState();
  const [playing, setPlaying] = useState(false);
  const [videoTime, setVideoTime] = useState(0);
  const [currentTime, setCurrentTime] = useState();
  const [progress, setProgress] = useState(0);
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const [state, setState] = useState(false);
  const [lastlesson, setLastLesson] = useState();
  const [lastlessonNo, setLastLessonNo] = useState();
  const [indexState, setIndexState] = useState(0);
  const [played, setPlayed] = useState(0);
  const videoRef = useRef(null);

  useEffect(() => {
    getAllLessons();
    getUserProgress();
  }, []);

  useEffect(() => {
    if (
      videoRef?.current?.currentTime > 0 &&
      videoRef?.current?.currentTime === videoRef?.current?.duration
    ) {
      getUserProgress();
    }
  }, [currentTime]);

  const getAllLessons = async () => {
    setLoading(true);
    await ApiGet(`lesson/get-lesson?cid=${id}&isActive=true`)
      .then((res) => {
        setLoading(false);
        console.log("get lesson", res?.data?.payload?.lesson[0]?._id);
        if (res?.data?.result === 0) {
          setLessonData(res?.data?.payload?.lesson);
          console.log("firstaaaaaaaaaaaa", res?.data?.payload?.lesson);
        }
      })
      .catch((err) => {
        console.log("err", err);
        toast.error(err?.response?.data?.message, { theme: "colored" });
      });
  };

  const getUserProgress = async () => {
    await ApiGet(`progress/get-progress?uid=${userInfo?._id}&cid=${id}`)
      .then((res) => {
        setLoading(false);
        console.log("getVideoProgress", res?.data?.payload);
        console.log(
          "getVideoProgress no",
          res?.data?.payload?.progress[0]?.lid?.lNumber
        );
        if (res?.data?.result === 0) {
          setLastLesson(res?.data?.payload?.progress);
          setLastLessonNo(res?.data?.payload?.progress[0]?.lid?.lNumber);
          if (
            !res?.data?.payload?.progress[0]?.lid?.lNumber ||
            res?.data?.payload?.progress[0]?.lid?.lNumber === undefined
          ) {
            console.log("panotiiii");
            setLastLessonNo(1);
            setIndexState(0);
          }
        }
      })
      .catch((err) => {
        console.log("err", err);
        toast.error(err?.response?.data?.message, { theme: "colored" });
      });
  };
  const VideoProgress = async () => {
    let progressData = {};
    progressData.uid = userInfo?._id;
    progressData.lid = lessonData?.[indexState]?._id;
    progressData.duration = videoTime;
    progressData.endTime = played;
    progressData.cid = id;

    await ApiPost("progress/add-progress", progressData).then((res) => {
      console.log("resvideo handler", res);
    });
  };

  if (typeof window !== "undefined") {
    window.setInterval(function () {
      setCurrentTime(videoRef.current?.currentTime);
      // setProgress((videoRef.current?.currentTime / videoTime) * 100);
    }, 1000);
  }

  const handleLessonProgress = (index) => {
    setPlaying(false);
    setVideoTime(0);
    setCurrentTime(0);
    setIndexState(index);
    setState(!state);
  };

  return (
    <div>
      <div className="courses-details-section">
        {/* <div className="page-title-alignment">
          <h1>{localStorage.getItem("CourseName")}</h1>
          <div className="icon-design">
            <img src={MusicIcon} alt="" />
          </div>
        </div> */}
        <div>
          {/* <div className="backSection"> */}
          {/* <div>
            <div className="heading">
              <h1>{localStorage.getItem("CourseName")}</h1>
            </div>
            <div
              onClick={() => history.goBack()}
              style={{ cursor: "pointer" }}
              className="btns"
            > */}
          {/* <svg
              width="8"
              height="12"
              viewBox="0 0 8 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.12109 11.2426C5.98975 11.2428 5.85968 11.2169 5.73835 11.1667C5.61702 11.1164 5.50682 11.0426 5.41409 10.9496L1.17188 6.70692C1.079 6.61409 1.00532 6.50387 0.95505 6.38256C0.90478 6.26124 0.878906 6.13121 0.878906 5.99989C0.878906 5.86858 0.90478 5.73855 0.95505 5.61723C1.00532 5.49592 1.079 5.38569 1.17188 5.29286L5.41406 1.05018C5.60158 0.862668 5.85591 0.757323 6.12109 0.757324C6.38628 0.757325 6.64061 0.862672 6.82812 1.05019C7.01564 1.23771 7.12099 1.49203 7.12099 1.75722C7.12098 2.02241 7.01564 2.27674 6.82812 2.46425L3.293 5.99992L6.82815 9.53556C6.96796 9.67542 7.06317 9.85358 7.10173 10.0475C7.1403 10.2415 7.1205 10.4425 7.04483 10.6252C6.96916 10.8079 6.84102 10.9641 6.67661 11.074C6.5122 11.1839 6.3189 11.2425 6.12115 11.2426L6.12109 11.2426Z"
                fill="#4D4D4D"
              />
            </svg> */}
          {/* <span>{"  "}Back</span>
            </div>
          </div>
          <br />
          <br /> */}
        </div>
        {/* </div> */}
        <br />

        <div className="flex-alignment">
          <div>
            <div className="heading">
              <h1>{localStorage.getItem("CourseName")}</h1>
            </div>
          </div>
          <div>
            <button
              className="btns"
              onClick={() => history.goBack()}
              style={{ cursor: "pointer" }}
            >
              Zurück
            </button>
          </div>
        </div>

        <Loader
          className="Loading"
          type="Puff"
          color="#5B5B5E"
          height={35}
          width={35}
          visible={loading}
        />

        {loading === false && lessonData?.length === 0 && (
          <p className="text">Keine Daten gefunden</p>
        )}

        {loading === false && lessonData?.length > 0 && (
          <>
            <div className="department-box">
              {/* <div> */}

              {lessonData?.map((item, index) => {
                return (
                  <>
                    {/* {console.log(
                      "lastlessonNoindex",
                      lastlessonNo < index + 1 ? true : false
                    )} */}
                    <button
                      disabled={
                        !lastlessonNo ? 0 : lastlessonNo < index ? true : false
                      }
                      onClick={() => handleLessonProgress(index)}
                      className={`${
                        indexState === index ? "active" : "deactive"
                      } && ${
                        !lastlessonNo
                          ? 0
                          : lastlessonNo < index
                          ? "disabled"
                          : ""
                      } `}
                    >
                      {/* Lektion {index + 1} */}
                      {item?.name}
                    </button>
                  </>
                );
              })}
              {/* <img src={nextarrow} alt="" className="next_arrow"/> */}
            </div>

            <div className="video-grid">
              <div className="video-grid-items">
                <div className="video-show-box">
                  <ReactPlayer
                    url={lessonData?.[indexState]?.video}
                    width="100%"
                    height="100%"
                    className="videoSection"
                    config={{ file: { attributes: { controlsList: 'nodownload' } } }}

                    ref={videoRef}
                    playing
                    controls
                    onProgress={(progress) => {
                      setPlayed(progress.playedSeconds);
                    }}
                    // onStart={() => {
                    //   VideoProgress();
                    // }}
                    // onPlay={() => {
                    //   VideoProgress();
                    // }}
                    onPause={() => {
                      VideoProgress();
                    }}
                    onEnded={() => {
                      getUserProgress();
                    }}
                    onDuration={(duration) => {
                      setVideoTime(duration);
                    }}
                  />

                  {/* <video
                    id="video1"
                    preload="auto"
                    src={lessonData?.[indexState]?.video}
                    alt=""
                    width="100%"
                    height="410px"
                    ref={videoRef}
                    className="videoSection"
                  /> */}

                  {/* <div className="videobtn">
                    <svg
                      width="78"
                      height="78"
                      viewBox="0 0 78 78"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M39 0C17.4622 0 0 17.4622 0 39C0 60.5377 17.4622 78 39 78C60.5377 78 78 60.5377 78 39C78 17.4622 60.5377 0 39 0ZM39 9.0454C55.5424 9.0454 68.9546 22.4576 68.9546 39C68.9546 55.5424 55.5424 68.9546 39 68.9546C22.4576 68.9546 9.0454 55.5424 9.0454 39C9.0454 22.4576 22.4576 9.0454 39 9.0454ZM29.25 19.5285V58.4714L58.5 39L29.25 19.5285Z"
                        fill="#3D3D3D"
                      />
                    </svg>
                  </div> */}
                  {/* <div className="videoContorl">
                    <div className="videoControlSection">
                      <div className="timeingSection">
                        <span>
                          {currentTime === undefined
                            ? "00:00"
                            : Math.floor(currentTime / 60) +
                              ":" +
                              ("0" + Math.floor(currentTime % 60)).slice(-2)}
                        </span>
                      </div>
                      {console.log("progress", progress)}

                      <div className="videoprogress">
                        <LinearProgress
                          color="warning"
                          variant="determinate"
                          value={progress}
                        />
                      </div>

                      <div className="timeing">
                        <span>
                          {Math.floor(videoTime / 60) +
                            ":" +
                            ("0" + Math.floor(videoTime % 60)).slice(-2)}
                        </span>
                      </div>
                    </div>

                    <div className="zoomSection">
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 13 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3.9 0H0.65C0.477609 0 0.312279 0.0684819 0.190381 0.190381C0.0684819 0.312279 0 0.477609 0 0.65V3.9C0 4.07239 0.0684819 4.23772 0.190381 4.35962C0.312279 4.48152 0.477609 4.55 0.65 4.55C0.822391 4.55 0.987721 4.48152 1.10962 4.35962C1.23152 4.23772 1.3 4.07239 1.3 3.9V1.3H3.9C4.07239 1.3 4.23772 1.23152 4.35962 1.10962C4.48152 0.987721 4.55 0.822391 4.55 0.65C4.55 0.477609 4.48152 0.312279 4.35962 0.190381C4.23772 0.0684819 4.07239 0 3.9 0ZM3.9 11.7H1.3V9.1C1.3 8.92761 1.23152 8.76228 1.10962 8.64038C0.987721 8.51848 0.822391 8.45 0.65 8.45C0.477609 8.45 0.312279 8.51848 0.190381 8.64038C0.0684819 8.76228 0 8.92761 0 9.1V12.35C0 12.5224 0.0684819 12.6877 0.190381 12.8096C0.312279 12.9315 0.477609 13 0.65 13H3.9C4.07239 13 4.23772 12.9315 4.35962 12.8096C4.48152 12.6877 4.55 12.5224 4.55 12.35C4.55 12.1776 4.48152 12.0123 4.35962 11.8904C4.23772 11.7685 4.07239 11.7 3.9 11.7ZM12.35 0H9.1C8.92761 0 8.76228 0.0684819 8.64038 0.190381C8.51848 0.312279 8.45 0.477609 8.45 0.65C8.45 0.822391 8.51848 0.987721 8.64038 1.10962C8.76228 1.23152 8.92761 1.3 9.1 1.3H11.7V3.9C11.7 4.07239 11.7685 4.23772 11.8904 4.35962C12.0123 4.48152 12.1776 4.55 12.35 4.55C12.5224 4.55 12.6877 4.48152 12.8096 4.35962C12.9315 4.23772 13 4.07239 13 3.9V0.65C13 0.477609 12.9315 0.312279 12.8096 0.190381C12.6877 0.0684819 12.5224 0 12.35 0ZM12.35 8.45C12.1776 8.45 12.0123 8.51848 11.8904 8.64038C11.7685 8.76228 11.7 8.92761 11.7 9.1V11.7H9.1C8.92761 11.7 8.76228 11.7685 8.64038 11.8904C8.51848 12.0123 8.45 12.1776 8.45 12.35C8.45 12.5224 8.51848 12.6877 8.64038 12.8096C8.76228 12.9315 8.92761 13 9.1 13H12.35C12.5224 13 12.6877 12.9315 12.8096 12.8096C12.9315 12.6877 13 12.5224 13 12.35V9.1C13 8.92761 12.9315 8.76228 12.8096 8.64038C12.6877 8.51848 12.5224 8.45 12.35 8.45Z"
                          fill="black"
                        />
                      </svg>
                    </div>

                    <div className="playSection">
                      <div onClick={(e) => revert(e)} className="prevIcon">
                        <svg
                          width="18"
                          height="13"
                          rotate="180"
                          viewBox="0 0 18 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="playbtn"
                        >
                          <path d="M16.3913 1.66211V6.85115V12.0402M12.932 1.66211V12.0402M1.40745 11.9629C1.52096 12.0093 1.64933 12.0402 1.77716 12.0402C1.97635 12.0402 2.17553 11.9629 2.34634 11.8389L9.38722 7.67293L9.4583 7.59537C9.64343 7.39409 9.74288 7.14638 9.74288 6.86754C9.74288 6.58869 9.64343 6.32542 9.4583 6.13971L9.38722 6.06214L2.34634 1.8653C2.09013 1.64845 1.72041 1.60203 1.40745 1.74131C1.05178 1.89616 0.824219 2.28343 0.824219 2.70156V11.0024C0.824219 11.4202 1.05178 11.8078 1.40745 11.9629Z" />
                        </svg>
                      </div>
                      {playing ? (
                        <>
                          <div onClick={() => videoHandler("pause")}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 320 512"
                              width="25"
                              height="25"
                              className="playbtn"
                            >
                              <path d="M272 63.1l-32 0c-26.51 0-48 21.49-48 47.1v288c0 26.51 21.49 48 48 48L272 448c26.51 0 48-21.49 48-48v-288C320 85.49 298.5 63.1 272 63.1zM80 63.1l-32 0c-26.51 0-48 21.49-48 48v288C0 426.5 21.49 448 48 448l32 0c26.51 0 48-21.49 48-48v-288C128 85.49 106.5 63.1 80 63.1z" />
                            </svg>
                          </div>
                        </>
                      ) : (
                        <>
                          <div onClick={() => videoHandler("play")}>
                            <svg
                              width="25"
                              height="25"
                              viewBox="0 0 11 13"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="playbtn"
                            >
                              <path d="M1.35471 11.9629C1.46822 12.0093 1.5966 12.0402 1.72443 12.0402C1.92361 12.0402 2.1228 11.9629 2.2936 11.8389L9.33448 7.6729L9.40556 7.59534C9.59069 7.39406 9.69015 7.14635 9.69015 6.86751C9.69015 6.58867 9.59069 6.32539 9.40556 6.13968L9.33448 6.06212L2.2936 1.86527C2.03739 1.64843 1.66767 1.602 1.35471 1.74128C0.999045 1.89613 0.771484 2.2834 0.771484 2.70153V11.0024C0.771484 11.4202 0.999045 11.8078 1.35471 11.9629Z" />
                            </svg>
                          </div>
                        </>
                      )}
                      <div onClick={(e) => fastForward(e)} className="nextIcon">
                        <svg
                          width="18"
                          height="13"
                          viewBox="0 0 18 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M16.3913 1.66211V6.85115V12.0402M12.932 1.66211V12.0402M1.40745 11.9629C1.52096 12.0093 1.64933 12.0402 1.77716 12.0402C1.97635 12.0402 2.17553 11.9629 2.34634 11.8389L9.38722 7.67293L9.4583 7.59537C9.64343 7.39409 9.74288 7.14638 9.74288 6.86754C9.74288 6.58869 9.64343 6.32542 9.4583 6.13971L9.38722 6.06214L2.34634 1.8653C2.09013 1.64845 1.72041 1.60203 1.40745 1.74131C1.05178 1.89616 0.824219 2.28343 0.824219 2.70156V11.0024C0.824219 11.4202 1.05178 11.8078 1.40745 11.9629Z" />
                        </svg>
                      </div>

                      volume btn
                      <div>
                        <svg
                          width="18"
                          height="15"
                          viewBox="0 0 18 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M15.5742 2.96387C15.5742 2.96387 17.044 4.43369 17.044 6.8834C17.044 9.3331 15.5742 10.8029 15.5742 10.8029" />
                          <path d="M1.36523 9.33281V5.41328C1.36523 5.1534 1.46847 4.90416 1.65224 4.7204C1.836 4.53664 2.08524 4.4334 2.34512 4.4334H4.98786C5.18142 4.43344 5.37065 4.37616 5.53169 4.26878L9.64034 1.52903C9.78805 1.43048 9.95976 1.37391 10.1371 1.36539C10.3145 1.35686 10.4908 1.39669 10.6473 1.48062C10.8038 1.56454 10.9345 1.68941 11.0255 1.84188C11.1166 1.99435 11.1644 2.16868 11.1641 2.34625V12.3998C11.1641 12.5772 11.116 12.7513 11.0248 12.9035C10.9336 13.0557 10.8029 13.1803 10.6465 13.264C10.49 13.3477 10.3138 13.3873 10.1366 13.3787C9.95945 13.3701 9.78791 13.3136 9.64034 13.2151L5.53169 10.4763C5.37054 10.3693 5.18132 10.3124 4.98786 10.3127H2.34512C2.08524 10.3127 1.836 10.2095 1.65224 10.0257C1.46847 9.84193 1.36523 9.59269 1.36523 9.33281Z" />
                        </svg>
                      </div>
                    </div>
                  </div> */}
                </div>

                <div className="video-title-alignment">
                  <div>
                    <p>{lessonData?.[indexState]?.name}</p>
                  </div>
                  {/* <div>
                    <svg
                      width="18"
                      height="16"
                      viewBox="0 0 18 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.3332 6.0587C17.2806 5.90627 17.1849 5.77239 17.0577 5.67328C16.9305 5.57418 16.7772 5.51411 16.6166 5.50037L11.8749 4.8087L9.7499 0.500365C9.68166 0.359473 9.57512 0.24065 9.44247 0.15751C9.30983 0.0743692 9.15645 0.0302734 8.9999 0.0302734C8.84335 0.0302734 8.68997 0.0743692 8.55732 0.15751C8.42468 0.24065 8.31814 0.359473 8.2499 0.500365L6.1249 4.80036L1.38323 5.50037C1.229 5.52229 1.084 5.587 0.964692 5.68716C0.84538 5.78733 0.756533 5.91893 0.708233 6.06703C0.664021 6.21176 0.660053 6.3658 0.696756 6.51261C0.733459 6.65942 0.809448 6.79347 0.916566 6.90037L4.35823 10.2337L3.5249 14.967C3.49126 15.1241 3.50369 15.2874 3.56072 15.4376C3.61775 15.5877 3.71693 15.7181 3.84634 15.8132C3.97575 15.9083 4.12988 15.9639 4.29017 15.9735C4.45047 15.983 4.61012 15.9461 4.7499 15.867L8.9999 13.642L13.2499 15.867C13.3669 15.933 13.4989 15.9675 13.6332 15.967C13.8098 15.9677 13.9819 15.9122 14.1249 15.8087C14.2542 15.7161 14.3543 15.5884 14.4133 15.4407C14.4724 15.2931 14.488 15.1316 14.4582 14.9754L13.6249 10.242L17.0666 6.9087C17.1869 6.80676 17.2758 6.67278 17.323 6.52232C17.3702 6.37186 17.3738 6.21109 17.3332 6.0587ZM12.2082 9.39203C12.1118 9.4857 12.0394 9.60132 11.9973 9.72902C11.9553 9.85672 11.9447 9.9927 11.9666 10.1254L12.5666 13.6254L9.43323 11.9587C9.31146 11.8985 9.17743 11.8671 9.04157 11.8671C8.9057 11.8671 8.77167 11.8985 8.6499 11.9587L5.51657 13.6254L6.11657 10.1254C6.13843 9.9927 6.12787 9.85672 6.08579 9.72902C6.04371 9.60132 5.97135 9.4857 5.8749 9.39203L3.3749 6.89203L6.88323 6.3837C7.01823 6.36492 7.14656 6.31332 7.25698 6.23341C7.3674 6.1535 7.45653 6.04773 7.51657 5.92537L8.9999 2.75037L10.5666 5.9337C10.6266 6.05606 10.7157 6.16183 10.8261 6.24174C10.9366 6.32165 11.0649 6.37325 11.1999 6.39203L14.7082 6.90037L12.2082 9.39203Z"
                        fill="black"
                      />
                    </svg>
                  </div> */}
                </div>
                {/* <div className="video-sub-title-alignment">
                  <div>
                    <svg
                      width="10"
                      height="8"
                      viewBox="0 0 10 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.16662 3.02886C9.1403 2.95265 9.09244 2.88571 9.02884 2.83615C8.96523 2.7866 8.88862 2.75657 8.80828 2.74969L6.43745 2.40386L5.37495 0.249694C5.34083 0.179248 5.28756 0.119837 5.22124 0.0782666C5.15491 0.0366963 5.07822 0.0146484 4.99995 0.0146484C4.92168 0.0146484 4.84499 0.0366963 4.77866 0.0782666C4.71234 0.119837 4.65907 0.179248 4.62495 0.249694L3.56245 2.39969L1.19162 2.74969C1.1145 2.76066 1.042 2.79301 0.982346 2.84309C0.92269 2.89318 0.878267 2.95898 0.854117 3.03303C0.83201 3.10539 0.830027 3.18241 0.848378 3.25582C0.86673 3.32922 0.904724 3.39625 0.958283 3.44969L2.67912 5.11636L2.26245 7.48303C2.24563 7.56154 2.25185 7.64323 2.28036 7.71829C2.30887 7.79335 2.35847 7.85857 2.42317 7.90611C2.48788 7.95365 2.56494 7.98148 2.64509 7.98626C2.72524 7.99103 2.80506 7.97255 2.87495 7.93303L4.99995 6.82053L7.12495 7.93303C7.18343 7.96602 7.24947 7.98325 7.31662 7.98303C7.40488 7.98334 7.49096 7.95562 7.56245 7.90386C7.62709 7.85755 7.67714 7.79371 7.70667 7.71988C7.7362 7.64605 7.74399 7.56531 7.72912 7.4872L7.31245 5.12053L9.03328 3.45386C9.09344 3.40289 9.1379 3.3359 9.16151 3.26067C9.18511 3.18544 9.18688 3.10506 9.16662 3.02886ZM6.60412 4.69553C6.55589 4.74236 6.51971 4.80017 6.49867 4.86402C6.47763 4.92787 6.47235 4.99586 6.48328 5.06219L6.78328 6.81219L5.21662 5.97886C5.15573 5.94874 5.08871 5.93307 5.02078 5.93307C4.95285 5.93307 4.88584 5.94874 4.82495 5.97886L3.25828 6.81219L3.55828 5.06219C3.56922 4.99586 3.56394 4.92787 3.5429 4.86402C3.52185 4.80017 3.48568 4.74236 3.43745 4.69553L2.18745 3.44553L3.94162 3.19136C4.00912 3.18197 4.07328 3.15617 4.12849 3.11622C4.1837 3.07626 4.22827 3.02338 4.25828 2.96219L4.99995 1.37469L5.78328 2.96636C5.8133 3.02754 5.85787 3.08043 5.91307 3.12038C5.96828 3.16034 6.03245 3.18614 6.09995 3.19553L7.85412 3.44969L6.60412 4.69553Z"
                        fill="black"
                      />
                    </svg>
                  </div>
                  <div>
                    <span>4.0</span>
                  </div>
                </div> */}
                <div className="all-sub-text-alignment">
                  <div className="first-texxt-alignment">
                    <p>{lessonData?.[indexState]?.description}</p>
                  </div>
                  <div className="file-text-alignment">
                    {/* <div>
                      <svg
                        width="15"
                        height="20"
                        viewBox="0 0 15 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.6875 8H5.625C5.87364 8 6.1121 7.89464 6.28791 7.70711C6.46373 7.51957 6.5625 7.26522 6.5625 7C6.5625 6.73478 6.46373 6.48043 6.28791 6.29289C6.1121 6.10536 5.87364 6 5.625 6H4.6875C4.43886 6 4.2004 6.10536 4.02459 6.29289C3.84877 6.48043 3.75 6.73478 3.75 7C3.75 7.26522 3.84877 7.51957 4.02459 7.70711C4.2004 7.89464 4.43886 8 4.6875 8V8ZM4.6875 10C4.43886 10 4.2004 10.1054 4.02459 10.2929C3.84877 10.4804 3.75 10.7348 3.75 11C3.75 11.2652 3.84877 11.5196 4.02459 11.7071C4.2004 11.8946 4.43886 12 4.6875 12H10.3125C10.5611 12 10.7996 11.8946 10.9754 11.7071C11.1512 11.5196 11.25 11.2652 11.25 11C11.25 10.7348 11.1512 10.4804 10.9754 10.2929C10.7996 10.1054 10.5611 10 10.3125 10H4.6875ZM15 6.94C14.9902 6.84813 14.9714 6.75763 14.9438 6.67V6.58C14.8987 6.47718 14.8385 6.38267 14.7656 6.3L9.14062 0.3C9.06313 0.222216 8.97452 0.158081 8.87813 0.11C8.85014 0.10576 8.82173 0.10576 8.79375 0.11C8.69851 0.0517412 8.59333 0.0143442 8.48438 0H2.8125C2.06658 0 1.35121 0.316071 0.823762 0.87868C0.296316 1.44129 0 2.20435 0 3V17C0 17.7956 0.296316 18.5587 0.823762 19.1213C1.35121 19.6839 2.06658 20 2.8125 20H12.1875C12.9334 20 13.6488 19.6839 14.1762 19.1213C14.7037 18.5587 15 17.7956 15 17V6.94ZM9.375 3.41L11.8031 6H10.3125C10.0639 6 9.8254 5.89464 9.64959 5.70711C9.47377 5.51957 9.375 5.26522 9.375 5V3.41ZM13.125 17C13.125 17.2652 13.0262 17.5196 12.8504 17.7071C12.6746 17.8946 12.4361 18 12.1875 18H2.8125C2.56386 18 2.3254 17.8946 2.14959 17.7071C1.97377 17.5196 1.875 17.2652 1.875 17V3C1.875 2.73478 1.97377 2.48043 2.14959 2.29289C2.3254 2.10536 2.56386 2 2.8125 2H7.5V5C7.5 5.79565 7.79632 6.55871 8.32376 7.12132C8.85121 7.68393 9.56658 8 10.3125 8H13.125V17ZM10.3125 14H4.6875C4.43886 14 4.2004 14.1054 4.02459 14.2929C3.84877 14.4804 3.75 14.7348 3.75 15C3.75 15.2652 3.84877 15.5196 4.02459 15.7071C4.2004 15.8946 4.43886 16 4.6875 16H10.3125C10.5611 16 10.7996 15.8946 10.9754 15.7071C11.1512 15.5196 11.25 15.2652 11.25 15C11.25 14.7348 11.1512 14.4804 10.9754 14.2929C10.7996 14.1054 10.5611 14 10.3125 14Z"
                          fill="black"
                        />
                      </svg>
                    </div> */}
                    {/* <div className="video-title-alignment">
                      <div>
                        <p>{localStorage.getItem("CourseName")}</p>
                      </div>
                      <div>
                        <svg
                          width="18"
                          height="16"
                          viewBox="0 0 18 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17.3332 6.0587C17.2806 5.90627 17.1849 5.77239 17.0577 5.67328C16.9305 5.57418 16.7772 5.51411 16.6166 5.50037L11.8749 4.8087L9.7499 0.500365C9.68166 0.359473 9.57512 0.24065 9.44247 0.15751C9.30983 0.0743692 9.15645 0.0302734 8.9999 0.0302734C8.84335 0.0302734 8.68997 0.0743692 8.55732 0.15751C8.42468 0.24065 8.31814 0.359473 8.2499 0.500365L6.1249 4.80036L1.38323 5.50037C1.229 5.52229 1.084 5.587 0.964692 5.68716C0.84538 5.78733 0.756533 5.91893 0.708233 6.06703C0.664021 6.21176 0.660053 6.3658 0.696756 6.51261C0.733459 6.65942 0.809448 6.79347 0.916566 6.90037L4.35823 10.2337L3.5249 14.967C3.49126 15.1241 3.50369 15.2874 3.56072 15.4376C3.61775 15.5877 3.71693 15.7181 3.84634 15.8132C3.97575 15.9083 4.12988 15.9639 4.29017 15.9735C4.45047 15.983 4.61012 15.9461 4.7499 15.867L8.9999 13.642L13.2499 15.867C13.3669 15.933 13.4989 15.9675 13.6332 15.967C13.8098 15.9677 13.9819 15.9122 14.1249 15.8087C14.2542 15.7161 14.3543 15.5884 14.4133 15.4407C14.4724 15.2931 14.488 15.1316 14.4582 14.9754L13.6249 10.242L17.0666 6.9087C17.1869 6.80676 17.2758 6.67278 17.323 6.52232C17.3702 6.37186 17.3738 6.21109 17.3332 6.0587ZM12.2082 9.39203C12.1118 9.4857 12.0394 9.60132 11.9973 9.72902C11.9553 9.85672 11.9447 9.9927 11.9666 10.1254L12.5666 13.6254L9.43323 11.9587C9.31146 11.8985 9.17743 11.8671 9.04157 11.8671C8.9057 11.8671 8.77167 11.8985 8.6499 11.9587L5.51657 13.6254L6.11657 10.1254C6.13843 9.9927 6.12787 9.85672 6.08579 9.72902C6.04371 9.60132 5.97135 9.4857 5.8749 9.39203L3.3749 6.89203L6.88323 6.3837C7.01823 6.36492 7.14656 6.31332 7.25698 6.23341C7.3674 6.1535 7.45653 6.04773 7.51657 5.92537L8.9999 2.75037L10.5666 5.9337C10.6266 6.05606 10.7157 6.16183 10.8261 6.24174C10.9366 6.32165 11.0649 6.37325 11.1999 6.39203L14.7082 6.90037L12.2082 9.39203Z"
                            fill="black"
                          />
                        </svg>
                      </div>
                    </div> */}
                    {/* <div className="video-sub-title-alignment">
                      <div>
                        <svg
                          width="10"
                          height="8"
                          viewBox="0 0 10 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9.16662 3.02886C9.1403 2.95265 9.09244 2.88571 9.02884 2.83615C8.96523 2.7866 8.88862 2.75657 8.80828 2.74969L6.43745 2.40386L5.37495 0.249694C5.34083 0.179248 5.28756 0.119837 5.22124 0.0782666C5.15491 0.0366963 5.07822 0.0146484 4.99995 0.0146484C4.92168 0.0146484 4.84499 0.0366963 4.77866 0.0782666C4.71234 0.119837 4.65907 0.179248 4.62495 0.249694L3.56245 2.39969L1.19162 2.74969C1.1145 2.76066 1.042 2.79301 0.982346 2.84309C0.92269 2.89318 0.878267 2.95898 0.854117 3.03303C0.83201 3.10539 0.830027 3.18241 0.848378 3.25582C0.86673 3.32922 0.904724 3.39625 0.958283 3.44969L2.67912 5.11636L2.26245 7.48303C2.24563 7.56154 2.25185 7.64323 2.28036 7.71829C2.30887 7.79335 2.35847 7.85857 2.42317 7.90611C2.48788 7.95365 2.56494 7.98148 2.64509 7.98626C2.72524 7.99103 2.80506 7.97255 2.87495 7.93303L4.99995 6.82053L7.12495 7.93303C7.18343 7.96602 7.24947 7.98325 7.31662 7.98303C7.40488 7.98334 7.49096 7.95562 7.56245 7.90386C7.62709 7.85755 7.67714 7.79371 7.70667 7.71988C7.7362 7.64605 7.74399 7.56531 7.72912 7.4872L7.31245 5.12053L9.03328 3.45386C9.09344 3.40289 9.1379 3.3359 9.16151 3.26067C9.18511 3.18544 9.18688 3.10506 9.16662 3.02886ZM6.60412 4.69553C6.55589 4.74236 6.51971 4.80017 6.49867 4.86402C6.47763 4.92787 6.47235 4.99586 6.48328 5.06219L6.78328 6.81219L5.21662 5.97886C5.15573 5.94874 5.08871 5.93307 5.02078 5.93307C4.95285 5.93307 4.88584 5.94874 4.82495 5.97886L3.25828 6.81219L3.55828 5.06219C3.56922 4.99586 3.56394 4.92787 3.5429 4.86402C3.52185 4.80017 3.48568 4.74236 3.43745 4.69553L2.18745 3.44553L3.94162 3.19136C4.00912 3.18197 4.07328 3.15617 4.12849 3.11622C4.1837 3.07626 4.22827 3.02338 4.25828 2.96219L4.99995 1.37469L5.78328 2.96636C5.8133 3.02754 5.85787 3.08043 5.91307 3.12038C5.96828 3.16034 6.03245 3.18614 6.09995 3.19553L7.85412 3.44969L6.60412 4.69553Z"
                            fill="black"
                          />
                        </svg>
                      </div>
                      <div>
                        <span>4.0</span>
                      </div>
                    </div> */}
                    <div className="all-sub-text-alignment">
                      {/* <div className="first-texxt-alignment">
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit. Sed tellus ut condimentum pretium, at. Justo
                          enim, accumsan faucibus scelerisque. Purus non sociis
                          diam quis a. Mi facilisis adipiscing ultricies odio
                          turpis nibh.
                        </p>
                      </div> */}
                      <div className="file-text-alignment">
                        {/* <div>
                          <svg
                            width="15"
                            height="20"
                            viewBox="0 0 15 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M4.6875 8H5.625C5.87364 8 6.1121 7.89464 6.28791 7.70711C6.46373 7.51957 6.5625 7.26522 6.5625 7C6.5625 6.73478 6.46373 6.48043 6.28791 6.29289C6.1121 6.10536 5.87364 6 5.625 6H4.6875C4.43886 6 4.2004 6.10536 4.02459 6.29289C3.84877 6.48043 3.75 6.73478 3.75 7C3.75 7.26522 3.84877 7.51957 4.02459 7.70711C4.2004 7.89464 4.43886 8 4.6875 8V8ZM4.6875 10C4.43886 10 4.2004 10.1054 4.02459 10.2929C3.84877 10.4804 3.75 10.7348 3.75 11C3.75 11.2652 3.84877 11.5196 4.02459 11.7071C4.2004 11.8946 4.43886 12 4.6875 12H10.3125C10.5611 12 10.7996 11.8946 10.9754 11.7071C11.1512 11.5196 11.25 11.2652 11.25 11C11.25 10.7348 11.1512 10.4804 10.9754 10.2929C10.7996 10.1054 10.5611 10 10.3125 10H4.6875ZM15 6.94C14.9902 6.84813 14.9714 6.75763 14.9438 6.67V6.58C14.8987 6.47718 14.8385 6.38267 14.7656 6.3L9.14062 0.3C9.06313 0.222216 8.97452 0.158081 8.87813 0.11C8.85014 0.10576 8.82173 0.10576 8.79375 0.11C8.69851 0.0517412 8.59333 0.0143442 8.48438 0H2.8125C2.06658 0 1.35121 0.316071 0.823762 0.87868C0.296316 1.44129 0 2.20435 0 3V17C0 17.7956 0.296316 18.5587 0.823762 19.1213C1.35121 19.6839 2.06658 20 2.8125 20H12.1875C12.9334 20 13.6488 19.6839 14.1762 19.1213C14.7037 18.5587 15 17.7956 15 17V6.94ZM9.375 3.41L11.8031 6H10.3125C10.0639 6 9.8254 5.89464 9.64959 5.70711C9.47377 5.51957 9.375 5.26522 9.375 5V3.41ZM13.125 17C13.125 17.2652 13.0262 17.5196 12.8504 17.7071C12.6746 17.8946 12.4361 18 12.1875 18H2.8125C2.56386 18 2.3254 17.8946 2.14959 17.7071C1.97377 17.5196 1.875 17.2652 1.875 17V3C1.875 2.73478 1.97377 2.48043 2.14959 2.29289C2.3254 2.10536 2.56386 2 2.8125 2H7.5V5C7.5 5.79565 7.79632 6.55871 8.32376 7.12132C8.85121 7.68393 9.56658 8 10.3125 8H13.125V17ZM10.3125 14H4.6875C4.43886 14 4.2004 14.1054 4.02459 14.2929C3.84877 14.4804 3.75 14.7348 3.75 15C3.75 15.2652 3.84877 15.5196 4.02459 15.7071C4.2004 15.8946 4.43886 16 4.6875 16H10.3125C10.5611 16 10.7996 15.8946 10.9754 15.7071C11.1512 15.5196 11.25 15.2652 11.25 15C11.25 14.7348 11.1512 14.4804 10.9754 14.2929C10.7996 14.1054 10.5611 14 10.3125 14Z"
                              fill="black"
                            />
                          </svg>
                        </div> */}
                        <div>
                          {/* {console.log("aaaaa")}
                          {lessonData?.[indexState]?.pdf?.length > 0 &&
                            lessonData?.[indexState]?.pdf?.map(
                              ({ name, link ,buttonName}) => (
                                <p>
                                  Click{" "}
                                  <a target="_blank" href={link}>
                                  <b>{buttonName ? buttonName : "here"}</b>
                                  </a>{" "}
                                  to download <b>{name}</b>
                                </p>
                              )
                            )} */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="button-wrapper">
                {lessonData?.[indexState]?.pdf?.length > 0 &&
                  lessonData?.[indexState]?.pdf?.map(({ link, buttonName }) => (
                    <a target="_blank" href={link}>
                      <button className="downloadbtn">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M19 22H5C3.34389 21.9982 2.00181 20.6561 2 19V15C2 14.4477 2.44772 14 3 14C3.55228 14 4 14.4477 4 15V19C4.00037 19.5521 4.44787 19.9996 5 20H19C19.5521 19.9996 19.9996 19.5521 20 19V15C20 14.4477 20.4477 14 21 14C21.5523 14 22 14.4477 22 15V19C21.9982 20.6561 20.6561 21.9982 19 22Z"
                            fill="white"
                          />
                          <path
                            d="M16.707 10.293C16.3167 9.90252 15.6838 9.90235 15.2933 10.2926C15.2932 10.2927 15.2931 10.2929 15.2929 10.293L13 12.5859V3C13 2.44772 12.5523 2 12 2C11.4477 2 11 2.44772 11 3V12.5859L8.70699 10.293C8.31297 9.90609 7.6799 9.91184 7.29299 10.3059C6.91104 10.6948 6.91104 11.318 7.29299 11.707L11.293 15.707C11.6833 16.0975 12.3162 16.0976 12.7067 15.7074C12.7068 15.7072 12.7069 15.7071 12.7071 15.707L16.7071 11.707C17.0975 11.3167 17.0976 10.6838 16.7073 10.2933C16.7072 10.2932 16.7071 10.2931 16.707 10.293Z"
                            fill="white"
                          />
                        </svg>
                        {buttonName}
                      </button>{" "}
                    </a>
                  ))}
              </div>

              {/* <div className="video-grid-items">
                <div className="white-dummy-box"></div>
              </div> */}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
